import { Mechanics } from "game-common/mechanics/mechanics"
import { Entity, TileSize } from "game-common/models"
import { floorFallZIndex } from "./effects/floor_fall"
import type { ClientRenderable } from "./entity_rendering_manager"
import type { TileMapMetaProvider } from "game-common/tile_map_meta_provider"

export function initializeEntityDepth(entity: Entity, sprite: ClientRenderable, provider?: TileMapMetaProvider): void {
    if (entity.npcType !== "marker" || !entity.spriteId) return
    const offset = provider?.resolveTileMeta(entity.spriteId)?.renderZIdxOffset
    if (offset !== undefined) sprite.defaultZIndex = offset
    sprite.zIndex = entityDepth(entity, sprite.defaultZIndex, provider)
}

/** Shared by active-room bodies and the projected bodies on other floors. */
export const entityDepth = (entity: Entity, defaultZIndex = 0, provider?: TileMapMetaProvider): number => {
    // A shaft spans several floor renderings; its climber must draw over every section.
    // Standing on either endpoint keeps this priority until the entity steps off.
    if (!entity.floorFall && (entity.stairTravel || provider?.isStairAt(
        Math.floor(entity.location.x / TileSize), Math.floor(entity.location.y / TileSize)))) return 999998

    const flat = Mechanics.entity.body.isFlat(entity) || entity.downed ||
        entity.floorFall?.phase === "landed" || entity.rescuePose === "downed"
    const depth = flat ? 0 : Mechanics.entity.body.calculateZIndexBoost(entity) + defaultZIndex || 0
    return floorFallZIndex(entity, depth)
}
